import { PaymentType } from '@domgen/dgx-fe-common';

export interface CheckoutCardPaymentDetails {
  cardPaymentReference: string;
  paymentType: PaymentType.Card;
}
